import {Component, OnInit, OnDestroy} from '@angular/core';
import {Constants} from 'config/constants';
import {Router, NavigationEnd, Event} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';

@Component({
    selector: 'tpc-business-calculator',
    templateUrl: './business-calculator.component.html',
    styleUrls: ['./business-calculator.component.css']
})
export class BusinessCalculatorComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription;

    public isGatePage = false;
    public calculatorName: string = Constants.calculators.business;
    public menuItems: Array<any> = [{
        name: 'site',
        title: 'Site',
        url: '/business/site',
        checked: false
    }, {
        name: 'fleet',
        title: 'Fleet',
        url: '/business/fleet',
        checked: false
    }, {
        name: 'travel',
        title: 'Air Travel',
        url: '/business/travel',
        checked: false
    }, {
        name: 'commute',
        title: 'Commute',
        url: '/business/commute',
        checked: false
    }, {
        name: 'shipping',
        title: 'Shipping',
        url: '/business/shipping',
        checked: false
    }, {
        name: 'server',
        title: 'Server',
        url: '/business/server',
        checked: false
    }];

    constructor(private router: Router) {
        this.routerSubscription = router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.isGatePage = event.urlAfterRedirects.includes('/gate/default');
            }
        });
    }

    ngOnInit() {
    }

    ngOnDestroy () {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/business-calculator.component.ts